import styles from './product-structure-grid.module.scss';
import { useState } from 'react';
import { Box, Tab, Tabs } from '@frontend-workspace/react-shared-lib';
import Groups from './tab-panels/groups/groups';
import ProductList from './tab-panels/product-list/product-list';
import Items from './tab-panels/items/items';
import Import from './tab-panels/import/import';
import AutodeskCatalog from '../../autodesk-catalog/autodesk-catalog';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface ProductStructureGridProps { }

export function ProductStructureGrid(props: ProductStructureGridProps) {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const navigateToTabOne = () => setSelectedTab(0);
  const navigateToTabTwo = () => setSelectedTab(1);
  const navigateToTabThree = () => setSelectedTab(2);
  const navigateToTabFour = () => setSelectedTab(3);
  const navigateToTabFive = () => setSelectedTab(4);

  return <>
    <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: '20px' }}>
      <Tabs
        value={selectedTab}
        variant="scrollable"
        scrollButtons="auto">
        <Tab label={t("productStructureGrid.groups")} onClick={navigateToTabOne} />
        <Tab label={t("standard.productList")} onClick={navigateToTabTwo} />
        <Tab label={t("productStructureGrid.contractItems")} onClick={navigateToTabThree} />
        <Tab label={t("productStructureGrid.itemsImport")} onClick={navigateToTabFour} />
        <Tab label={t("productStructureGrid.autodeskImport")} onClick={navigateToTabFive} />
      </Tabs>
    </Box>
    {selectedTab === 0 && <Groups />}
    {selectedTab === 1 && <ProductList />}
    {selectedTab === 2 && <Items />}
    {selectedTab === 3 && <Import />}
    {selectedTab === 4 && <AutodeskCatalog />}
  </>;
}

export default ProductStructureGrid;